import React, { useRef } from "react"

/** @param {HTMLInputElement | null | undefined} input */
function openNativeDatePicker(input) {
    if (!input || typeof input.showPicker !== "function") {
        return false
    }
    try {
        input.showPicker()
        return true
    } catch {
        return false
    }
}

/** @param {HTMLInputElement | null | undefined} input */
function closeNativeDatePicker(input) {
    if (!input || typeof input.hidePicker !== "function") {
        return false
    }
    try {
        input.hidePicker()
        return true
    } catch {
        return false
    }
}

/**
 * Native date input: click opens the picker when closed; click again (or blur) closes it.
 *
 * @param {React.InputHTMLAttributes<HTMLInputElement>} props
 */
export default function DateInput({
    onClick,
    onBlur,
    onChange,
    className = "form-control",
    ...rest
}) {
    const pickerOpenRef = useRef(false)

    function markPickerClosed() {
        pickerOpenRef.current = false
    }

    return (
        <input
            type="date"
            className={className}
            onClick={(event) => {
                const input = event.currentTarget
                if (pickerOpenRef.current) {
                    closeNativeDatePicker(input)
                    markPickerClosed()
                } else if (openNativeDatePicker(input)) {
                    pickerOpenRef.current = true
                }
                onClick?.(event)
            }}
            onBlur={(event) => {
                markPickerClosed()
                onBlur?.(event)
            }}
            onChange={(event) => {
                markPickerClosed()
                onChange?.(event)
            }}
            {...rest}
        />
    )
}
